import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { params, shape, string as stringType, useDataModel } from '@thd-nucleus/data-sources';
import { Carousel } from '@one-thd/sui-carousel';
import { Typography, Link } from '@one-thd/sui-atomic-components';
import ListPod from './List/ListPod';
import { fetchJson, getJsonPath } from '../utils/util';
import { BREAK_POINTS, TITLE } from '../utils/consts';
import ListLoader from './List/ListLoader';

const GiftCardsCarousel = ({ jsonType }) => {
  const [masterData, setMasterData] = useState([]);
  const [title, setTitle] = useState('');
  const { firstPartyJsonUrl, thirdPartyJsonUrl } = getJsonPath();
  const bestSeller = masterData.filter((list) => list?.occasions?.includes('Best Sellers'));

  const fetchMasterData = async function () {
    let fetchData = [];
    if (jsonType === 1) {
      setTitle(TITLE.homeDepot);
      fetchData = await fetchJson(firstPartyJsonUrl);
    } else if (jsonType === 2) {
      setTitle(TITLE.specialty);
      fetchData = await fetchJson(thirdPartyJsonUrl);
    } else if (jsonType === 3) {
      const fetchData1 = await fetchJson(firstPartyJsonUrl);
      const fetchData2 = await fetchJson(thirdPartyJsonUrl);
      fetchData = fetchData1.concat(fetchData2);
    }
    setMasterData(fetchData);
  };

  useEffect(() => {
    fetchMasterData();
  }, []);

  if (masterData?.length < 1) return <ListLoader />;

  return (
    <Carousel
      title={<Typography variant="h3" weight="display">{`Shop ${title}Gift Cards`}</Typography>}
      action={<Link href="/c/gift-cards">See All</Link>}
      breakpoints={BREAK_POINTS}
      slidesPerView={1}
      slidesPerGroup={1}
    >
      {bestSeller?.map((item, index) => {
        return <ListPod key={index} item={item} />;
      })}
    </Carousel>
  );
};

GiftCardsCarousel.propTypes = {
  jsonType: PropTypes.number
};

GiftCardsCarousel.defaultProps = {
  jsonType: 1
};

GiftCardsCarousel.dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    dataSource: stringType(),
    identifiers: shape({
      productLabel: stringType()
    })
  })
};

export { GiftCardsCarousel };
